import { DynamicTable } from "@workspace/common";
import React, { useEffect } from "react";
import { Row, Col, Input } from "reactstrap";
import { useSelector } from "react-redux";
import { JOB_INITIAL_OPTIONS } from "./CandidateTaggingConstants";
import TableRowsPerPageWithNav from "@workspace/common/src/Components/DynamicTable/TableRowsPerPageWithNav";
import TableItemDisplay from "@workspace/common/src/Components/DynamicTable/TableItemDisplay";

function DynamicTableWrapper({
  data,
  config,
  pageInfo,
  pageRequest,
  pageRequestSet,
  search,
  setSearch,
  setCustomConfigData,
  gridView,
  activeRow,
  setActiveRow,
  setTableConfig,
}) {
  const jobsMeta = useSelector((state) => state.JobListReducer.jobsMeta);

  useEffect(() => {
    setCustomConfigData(JOB_INITIAL_OPTIONS);
  }, []);

  return (
    <div>
      <Row>
        <div className="d-flex flex-row align-items-center justify-content-between">
          <div>
            {setSearch && (
              <div className="search-box">
                <form onSubmit={pageRequestSet.setSearchTerm}>
                  <Input
                    type="text"
                    placeholder="Search"
                    className="form-control search"
                    value={search}
                    style={{
                      width: "250px",
                      borderColor: "#d3d3d3",
                    }}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </form>
                <i className="ri-search-line search-icon"></i>
              </div>
            )}
          </div>
          <div>
            <div className="d-flex flex-row align-items-center gap-2">
              <TableItemDisplay pageInfo={pageInfo} />
              <div
                style={{
                  width: "2px",
                  height: "20px",
                  backgroundColor: "#adb5bd",
                  marginLeft: "12px",
                }}
              ></div>
              <TableRowsPerPageWithNav
                pageInfo={pageInfo}
                pageRequestSet={pageRequestSet}
              />
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <Col lg={12}>
          <DynamicTable
            config={config}
            data={data}
            pageRequestSet={pageRequestSet}
            pageInfo={pageInfo}
            isLoading={jobsMeta?.isLoading ?? true}
            freezeHeader={true}
            activeRow={activeRow}
            setTableConfig={setTableConfig}
            pageRequest={pageRequest}
            tableHeight="100%"
          />
        </Col>
      </Row>
    </div>
  );
}

export default DynamicTableWrapper;
